<div class="time-adjustments-container">
  <div class="header">
    <h2>Time Adjustments</h2>
  </div>

<!-- Team Summary Section (TManager only) -->

    <div *ngIf="managerStatus === 'TManager'" class="team-summary-section">


      <div class="form-group" style="margin-bottom: 15px; max-width: 400px;">
        <label for="region-select">Territories</label>
        <select 
          id="region-select"
          [(ngModel)]="selectedTerritoryManagerId" 
          (change)="onTerritoryManagerChange()"
          class="form-control">
          <option [value]="null">View a different manager...</option>
          <option *ngFor="let supervisor of supervisors" [value]="supervisor.employee_id">
            {{ supervisor.employee_name}} - {{ supervisor.region }}
          </option>
        </select>
      </div>

  
      <div>
        <button class="week-toggle-button" *ngIf="!currentWeekLoaded" (click)="loadCurrentWeek()">Load Current Week</button>
        <button class="week-toggle-button" *ngIf="!previousWeekLoaded" (click)="loadPreviousWeek()">Load Previous Week</button>
      </div>

      <!-- Collapsible Header -->
      <div class="collapsible-header" (click)="toggleTeamApprovalCollapse()">
        <div class="team-header-content">
          <h3>Team Approval - {{weekText}} {{selectedApprovalRange}}</h3>
          <div class="team-stats">
            <span class="stat-item">
              <strong>Total Team Hours:</strong> {{ sumHoursThisWeek  | number:'1.2-2' }}
            </span>
            <span class="stat-item">
              <strong>Team Members:</strong> {{ teamHoursData.length }}
            </span>
            <span class="stat-item">
              <strong>Already Approved:</strong> {{ getExistingApprovalCount() }}
            </span>
            <span class="stat-item">
              <strong>Needing Approvals:</strong> {{ teamHoursData.length - getExistingApprovalCount() }}
            </span>
          </div>
        </div>
        <div class="collapse-icon">
          <span [class.rotated]="!isTeamApprovalCollapsed">▼</span>
        </div>
      </div>

      <!-- Collapsible Content -->
      <div class="collapsible-content" [class.collapsed]="isTeamApprovalCollapsed">
    
        <!-- Loading State -->
        <div *ngIf="isLoadingTeamHours" class="loading">
          <div class="loading-spinner"></div>
          <p>Loading team hours...</p>
        </div>

        <!-- Approval Section -->
        <div *ngIf="!isLoadingTeamHours && teamHoursData.length > 0" class="approval-section">
      
          <!-- Bulk Actions -->
          <div class="bulk-actions" *ngIf="teamHoursData.length > 0">
            <label class="bulk-checkbox">
              <input 
                *ngIf="getExistingApprovalCount() !== teamHoursData.length"
                type="checkbox" 
                [checked]="isAllSelected()"
                [indeterminate]="isPartiallySelected()"
                (change)="onSelectAllChange($event.target.checked)">
              <span class="bulk-label" *ngIf="getExistingApprovalCount() !== teamHoursData.length">
                {{ isAllSelected() ? 'Deselect All' : 'Select All' }} 
                ({{ getApprovedCount() }}/{{ teamHoursData.length }})
              </span>
            </label>
          </div>


          <!-- Employee Approval List -->
          <div class="approval-list">

            <div *ngFor="let emp of teamHoursData; trackBy: trackByEmployeeId" 
                class="approval-item"
                [class.approved]="approvalStates[emp.employeeId]"
                [class.pending]="!approvalStates[emp.employeeId]"
                [class.already-approved]="isEmployeeAlreadyApproved(emp.employeeId)">
      
                <div class="approval-checkbox">
                    <input 
                        type="checkbox" 
                        [id]="'approve-' + emp.employeeId"
                        [checked]="approvalStates[emp.employeeId]"
                        [disabled]="isEmployeeAlreadyApproved(emp.employeeId)"
                        (change)="onApprovalChange(emp.employeeId, $event.target.checked)">
                </div>
      
                <div class="employee-info">
                    <div class="employee-header">
                        <span class="employee-name">{{ emp.employeeName }}</span>
                        <span *ngIf="getEmployeeNoteCount(emp.employeeId) > 0"
                              style="display: inline-flex; align-items: center; cursor: pointer; margin-left: 8px; vertical-align: middle;"
                              (click)="viewEmployeeNotes(emp, $event)"
                              title="View timecard notes">
                            <span style="background: #477333; color: white; border-radius: 50%;
                                  width: 20px; height: 20px; display: inline-flex; align-items: center;
                                  justify-content: center; font-size: 11px; font-weight: 500;">
                              {{ getEmployeeNoteCount(emp.employeeId) }}
                            </span>
                            <i class="fa fa-sticky-note-o" style="color: #477333; font-size: 14px; margin-left: 3px;"></i>
                        </span>
                        <span class="employee-hours">{{ emp.totalHours | number:'1.2-2' }}h
                          ({{ hourAmountToHoursAndMinutes(emp.totalHours) }})
                        </span>
                    </div>
                    <div class="employee-details">
                        <span class="employee-type">{{ emp.employeeType }}</span>
                    </div>
                </div>

                <div class="approval-status">
                    <span *ngIf="isEmployeeAlreadyApproved(emp.employeeId)" class="status-already-approved">
                        Previously Approved
                    </span>
                    <span *ngIf="!isEmployeeAlreadyApproved(emp.employeeId) && approvalStates[emp.employeeId]" class="status-approved">
                        Ready
                    </span>
                    <span *ngIf="!isEmployeeAlreadyApproved(emp.employeeId) && !approvalStates[emp.employeeId]" class="status-pending">
                        Pending
                    </span>
                </div>
            </div>

          </div>

          <!-- Save Button -->
          <div class="approval-actions">

              <button 
                  type="button"
                  class="btn btn-success approval-btn"
                  [disabled]="!hasApprovalChanges || isSavingApprovals || getNewApprovalCount() === 0"
                  (click)="saveApprovals()">
                  <span *ngIf="isSavingApprovals" class="loading-text">Processing...</span>
                  <span *ngIf="!isSavingApprovals && getNewApprovalCount() > 0">
                      Approve {{ getNewApprovalCount() }} New Employee{{ getNewApprovalCount() === 1 ? '' : 's' }}
                      <small *ngIf="getExistingApprovalCount() > 0">
                          ({{ getExistingApprovalCount() }} already approved)
                      </small>
                  </span>
                  <span *ngIf="!isSavingApprovals && getNewApprovalCount() === 0">
                      All Selected Already Approved
                  </span>
              </button>

          </div>
        </div>

        <!-- No Data State -->
        <div *ngIf="!isLoadingTeamHours && teamHoursData.length === 0" class="no-team-data">
          <p>No team members found or no hours recorded for this week.</p>
        </div>
    
      </div>
    </div>




  <!-- Selection Controls -->
  <div class="instructions-class" id="instructions">
    <p *ngIf="managerStatus === 'TManager'" class="description">Select an employee and week to view and edit time records</p>
    <p *ngIf="managerStatus !== 'TManager'" class="description">Select a week to view and edit your time records</p>
  </div>
  <div class="selection-controls">
    <div class="form-group" *ngIf="managerStatus === 'TManager'">
      <label for="employee-select">Employee:</label>
      <select 
        id="employee-select"
        [(ngModel)]="selectedEmployeeId" 
        (change)="onEmployeeChange()"
        class="form-control">
        <option [value]="null">Select an employee...</option>
        <option *ngFor="let employee of employees" [value]="employee.id">
          {{ employee.name }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="week-select">Week:</label>
      <select 
        id="week-select"
        [(ngModel)]="selectedWeek" 
        (change)="onWeekChange()"
        class="form-control">
        <option [value]="null">Select a week...</option>
        <option *ngFor="let week of weekOptions" [value]="week.value">
          {{ week.label }}
        </option>
      </select>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading">
    <div class="loading-spinner"></div>
    <p>Loading time records...</p>
  </div>

  <!-- Time Records Table -->
  <div *ngIf="!isLoading && selectedEmployeeId && selectedWeek" class="records-section">


    <!-- Week Status Banner -->
    <div *ngIf="!isWeekEditable()" class="week-status-banner" 
         [class.approved-banner]="isWeekApproved"
         [class.old-week-banner]="selectedWeek !== currentWeek">
        <div class="status-content">
            <span *ngIf="isWeekApproved">
              <i class="fa-solid fa-lock"></i>
            </span>

            <span class="status-icon" *ngIf="!isWeekApproved"></span>
            <span class="status-text">{{ getDisabledMessage() }}</span>
            <small class="status-detail" *ngIf="isWeekApproved && approvalDetails">
                Approved on {{ approvalDetails.approved_at | date:'MMM dd, yyyy HH:mm' }}
            </small>
            <small class="status-detail" *ngIf="!isWeekApproved">
                Current week: {{ currentWeekRange }}
            </small>
        </div>
    </div>

    <!-- Approval Status Loading -->
    <div *ngIf="weekApprovalStatus === 'checking'" class="approval-checking">
        <span class="checking-text">Checking approval status...</span>
    </div>

    
    <form [formGroup]="timeRecordsForm">
      <div *ngIf="recordsFormArray.length === 0" class="no-records">
        <p>No time records found for the selected employee and week.</p>
      </div>

      <div *ngIf="recordsFormArray.length > 0" class="table-container">
        <table class="time-records-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Day Start</th>
              <th>Day End</th>
              <th>Pause Time</th>
              <th>Time to First</th>
              <th>Time Home</th>
              <th>Paid Hours</th>
              <th></th>
            </tr>
          </thead>
          <tbody formArrayName="records">
            <tr *ngFor="let record of recordsFormArray.controls; let i = index" [formGroupName]="i">
              <td class="date-cell">
                {{ record.get('day')?.value | date:'mediumDate':'UTC' }}
              </td>
              <td>
                <input 
                  type="time" 
                  (blur)="onDayStartBlur(i)"
                  formControlName="daystart"
                  [class.disabled-input]="!isWeekEditable()"
                  class="form-control time-input"
                  [class.error]="record.get('daystart')?.invalid && record.get('daystart')?.touched">
              </td>
              <td>
                <div class="time-input-container">
                  <input 
                    type="time" 
                    (blur)="onDayEndBlur(i)"
                    formControlName="dayend"
                    [class.disabled-input]="!isWeekEditable()"
                    class="form-control time-input"
                    [class.error]="record.get('dayend')?.invalid && record.get('dayend')?.touched"
                    [class.missing-data]="!record.get('dayend')?.value">
                  <span 
                    *ngIf="!record.get('dayend')?.value && isWeekEditable() && !isCurrentDay(timeRecords[i])" 
                    class="missing-indicator"
                    title="Day end time is missing">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                  </span>
                </div>
              </td>
              <td>
                <input 
                  type="text" 
                  formControlName="pausetime"
                  [class.disabled-input]="!isWeekEditable()"
                  placeholder="00:00:00"
                  pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                  class="form-control interval-input"
                  [class.error]="record.get('pausetime')?.invalid && record.get('pausetime')?.touched">
              </td>
              <td>
                <input 
                  type="text" 
                  formControlName="timetofirst"
                  [class.disabled-input]="true"
                  placeholder="00:00:00"
                  pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                  class="form-control interval-input"
                  [class.error]="record.get('timetofirst')?.invalid && record.get('timetofirst')?.touched">
              </td>
              <td>
                <input 
                  type="text" 
                  formControlName="timehome"
                  [class.disabled-input]="true"
                  placeholder="00:00:00"
                  pattern="^([0-9]{1,2}):([0-5][0-9]):([0-5][0-9])$"
                  class="form-control interval-input">
              </td>
              <td class="total-hours">
                {{ calculateTotalHours(record).hoursFormat | number:'1.2-2' }}h
                ({{ calculateTotalHours(record).minutesFormat }})
              </td>
              <td>
                <button *ngIf="record.get('dayend')?.value" 
                (click)="openTimeCard(timeRecords[i])" 
                [class.disabled-input]="!isWeekEditable()"
                class="btn btn-primary save-btn timecard-btn">Timecard</button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="total-row">
              <td colspan="5"></td> 
              <td class="total-label" style="float:right;font-weight: 600;font-size:14px;">Total</td>
              <td class="total-cell"> 
                <span class="summary-value"> {{ getTotalPaidHours() }} </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div>

      </div>

      <!-- Save Button -->
      <div *ngIf="recordsFormArray.length > 0" class="save-section">


        <div class="save-controls">
          <button 
            type="button"
            (click)="saveChanges()"
            [disabled]="!hasUnsavedChanges || isLoading || !timeRecordsForm.valid"
            class="btn btn-primary save-btn">
            <span *ngIf="isLoading" class="loading-text">Saving...</span>
            <span *ngIf="!isLoading && !isWeekEditable()">Week Not Editable</span>
            <span *ngIf="!isLoading && getDirtyRecordCount() === 0 && isWeekEditable()">Save Changes</span>
            <span *ngIf="!isLoading && getDirtyRecordCount() > 0 && isWeekEditable()">Save Changes</span>

          </button>
          
          <div class="status-indicators">
            <span *ngIf="hasUnsavedChanges && !isLoading" class="unsaved-indicator">
              ● Unsaved changes
            </span>
            <span *ngIf="!hasUnsavedChanges && !isLoading" class="saved-indicator">
              ✓ All changes saved
            </span>
          </div>
        </div>
        
        <div *ngIf="!timeRecordsForm.valid" class="validation-errors">
          <p>Please fix the following errors before saving:</p>
          <ul>
            <li *ngFor="let record of recordsFormArray.controls; let i = index">
              <span *ngIf="record.get('daystart')?.invalid">Row {{ i + 1 }}: Day start is required (HH:MM:[AM/PM]) </span>
              <span *ngIf="record.get('dayend')?.invalid">Row {{ i + 1 }}: Day end is required (HH:MM:[AM/PM]) </span>
              <span *ngIf="record.get('pausetime')?.invalid">Row {{ i + 1 }}: Pause time is required</span>
              <span *ngIf="record.get('traveltime')?.invalid">Row {{ i + 1 }}: Travel time is required</span>
              <span *ngIf="record.get('timetofirst')?.invalid">Row {{ i + 1 }}: Time to first is required</span>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </div>

  <!-- Instructions -->
  <div *ngIf="!selectedEmployeeId || !selectedWeek" class="instructions">
    <div class="instructions-content">
      <h3>Getting Started</h3>
      <ol>
        <li>Select an employee from the dropdown</li>
        <li>Choose a week to view their time records</li>
        <li>Edit the time records directly in the table</li>
        <li>Click "Save Changes" to update the records</li>
      </ol>
    </div>
  </div>

  <div *ngIf="showReasonModal" class="modal-overlay" (click)="closeReasonModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Reason for Changes</h3>
        <button type="button" class="modal-close" (click)="closeReasonModal()">×</button>
      </div>
      
      <div class="modal-body">
        <p>You are about to save changes to <strong>{{ getDirtyRecordCount() }}</strong> time record{{ getDirtyRecordCount() === 1 ? '' : 's' }}.</p>
        <p>Please provide a reason for these changes:</p>
        
        <div class="form-group">
          <label for="save-reason">Reason <span class="required">*</span></label>
          <textarea
            id="save-reason"
            [(ngModel)]="saveReason"
            (input)="onReasonChange($event)"
            placeholder="Enter the reason for these time adjustments (minimum 5 characters)..."
            rows="3"
            class="form-control reason-textarea"
            [class.error]="saveReason.length > 0 && !isValidReason"
            maxlength="500">
          </textarea>
          <div class="character-count">
            {{ saveReason.length }}/500 characters
            <span *ngIf="saveReason.length > 0 && !isValidReason" class="error-text">
              (minimum 5 characters required)
            </span>
          </div>
          <p style="font-size: 1em; font-weight: 600;">All changes to time card adjustments must accurately reflect actual hours worked, and falsifying or altering entries may result in disciplinary action.</p>
        </div>
      </div>
      
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="closeReasonModal()">
          Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-primary"
          [disabled]="!hasUnsavedChanges || isLoading || 
          !timeRecordsForm.valid || 
          getDirtyRecordCount() === 0 || 
          !isWeekEditable()"
          (click)="confirmSave()">
          <span *ngIf="isLoading" class="loading-text">Saving...</span>
          <span *ngIf="!isLoading">Save Changes</span>
        </button>
      </div>
    </div>
  </div>


  <div *ngIf="showSuccessDialog" class="modal-overlay" (click)="hideSuccessModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Approvals Saved</h3>
        <button type="button" class="modal-close" (click)="hideSuccessModal()">×</button>
      </div>

      <div class="modal-body">
        <p>{{successMessage}}</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary"
          (click)="hideSuccessModal()">
          Ok
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showConfirmDialog" class="modal-overlay" (click)="hideConfirmModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Confirm Approval</h3>
        <button type="button" class="modal-close" (click)="hideConfirmModal()">×</button>
      </div>

      <div class="modal-body">
        <p>{{confirmMessage}}</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="hideConfirmModal()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="proceedWithApprovals()">
          Ok
        </button>
      </div>
    </div>
  </div>

</div>


<div *ngIf="isAdmin" class="admin-logs-section">
  <p>
    <button class="week-toggle-button" style="margin-right: 2em;height: 2em; font-size:2em;" (click)="openDayUpdateLogs()">View Time Adjustment Logs</button>
    <button class="week-toggle-button" style="height: 2em; font-size:2em;" (click)="openTimeAdjLogs()">View Approval Logs</button>
  </p>
</div>